import { vehicleModelsSlice } from "./vehicleModelsSlice";
import * as actions from "./vehicleModelsActions";
import * as selectors from "./vehicleModelsSelectors";

export { actions };
export { selectors };
export default vehicleModelsSlice.reducer;
